import singleUser from './src/main';

singleUser.install = function(Vue) {
  Vue.component(singleUser.name, singleUser);
};

export default singleUser;
